import { use_slice_ui } from '@/hooks/store/use_slices';

interface PROPS {
  class_name?: string;
  could_be_hidden?: boolean;
  children: React.ReactNode;
}

export function LAYOUT_COLUMN__base({ children, class_name, could_be_hidden = false }: PROPS) {
  const { global__hide_sidebars } = use_slice_ui(['global__hide_sidebars']);

  if (could_be_hidden && global__hide_sidebars) return null;

  /*
   *
   */
  return (
    <div
      className={`${class_name} flex-shrink-0 flex items-start gap-4 w-60 min-w-60 h-full shrink-0 select-none bg-bar border-component-border overflow-y-auto overflow-x-hidden min-w-0`}
    >
      {children}
    </div>
  );
}
